import {IFinanceReportBalance, IFinanceReportMarginality, IFinanceReportOpu, IFinanceReportRevenue} from "@retail-data-factory/rdf-angular-types-api";

export const mockFinanceReportRevenue: IFinanceReportRevenue = {
  months: [
    {
      year: '2017',
      approved: true,
      rows:[
        {rowCode: '01', rowName: '01', value: 100},
        {rowCode: '02', rowName: '02', value: 200},
        {rowCode: '03', rowName: '03', value: 500},
        {rowCode: '04', rowName: '04', value: 200},
        {rowCode: '05', rowName: '05', value: 300},
        {rowCode: '06', rowName: '06', value: 150},
        {rowCode: '07', rowName: '07', value: 80},
        {rowCode: '08', rowName: '08', value: 300},
        {rowCode: '09', rowName: '09', value: 200},
        {rowCode: '10', rowName: '10', value: 180},
        {rowCode: '11', rowName: '11', value: 300},
        {rowCode: '12', rowName: '12', value: 150}
        ]
    },
    {
      year: '2018',
      approved: true,
      rows:[
        {rowCode: '01', rowName: '01', value: 200},
        {rowCode: '02', rowName: '02', value: 300},
        {rowCode: '03', rowName: '03', value: 150},
        {rowCode: '04', rowName: '04', value: 80},
        {rowCode: '05', rowName: '05', value: 200},
        {rowCode: '06', rowName: '06', value: 250},
        {rowCode: '07', rowName: '07', value: 180},
        {rowCode: '08', rowName: '08', value: 200},
        {rowCode: '09', rowName: '09', value: 400},
        {rowCode: '10', rowName: '10', value: 280},
        {rowCode: '11', rowName: '11', value: 100},
        {rowCode: '12', rowName: '12', value: 250}
      ]
    },
    {
      year: '2019',
      approved: false,
      rows:[
        {rowCode: '01', rowName: '01', value: 200},
        {rowCode: '02', rowName: '02', value: 100},
        {rowCode: '03', rowName: '03', value: 300},
        {rowCode: '04', rowName: '04', value: 100},
        {rowCode: '05', rowName: '05', value: 200},
        {rowCode: '06', rowName: '06', value: 350},
        {rowCode: '07', rowName: '07', value: 100},
        {rowCode: '08', rowName: '08', value: 200},
        {rowCode: '09', rowName: '09', value: 300},
        {rowCode: '10', rowName: '10', value: 280},
        {rowCode: '11', rowName: '11', value: 200},
        {rowCode: '12', rowName: '12', value: 250}
      ]
    }
  ],
  quarts: [
    {  year: '2017', quart: '1', value: 100},
    {  year: '2017', quart: '2', value: 200},
    {  year: '2017', quart: '3', value: 300},
    {  year: '2017', quart: '4', value: 400},

    {  year: '2018', quart: '1', value: 300},
    {  year: '2018', quart: '2', value: 200},
    {  year: '2018', quart: '3', value: 400},
    {  year: '2018', quart: '4', value: 100},

    {  year: '2019', quart: '1', value: 500},
    {  year: '2019', quart: '2', value: 200},
    {  year: '2019', quart: '3', value: 400},
    {  year: '2019', quart: '4', value: 400}

  ],
  years: [
    {  rowCode: '2017', rowName: '2017', value: 100},
    {  rowCode: '2018', rowName: '2018', value: 500},
    {  rowCode: '2019', rowName: '2019', value: 200}
  ]
};
export const mockFinanceReportMarginality: IFinanceReportMarginality = {
  years: [
    {
      year: '2017',
      approved: true,
      rows:[
        {rowCode: '01', rowName: '01', value: 100},
        {rowCode: '02', rowName: '02', value: 200},
        {rowCode: '03', rowName: '03', value: 500},
        {rowCode: '04', rowName: '04', value: 200},
        {rowCode: '05', rowName: '05', value: 300},
        {rowCode: '06', rowName: '06', value: 150},
        {rowCode: '07', rowName: '07', value: 80},
        {rowCode: '08', rowName: '08', value: 300},
        {rowCode: '09', rowName: '09', value: 200},
        {rowCode: '10', rowName: '10', value: 180},
        {rowCode: '11', rowName: '11', value: 300},
        {rowCode: '12', rowName: '12', value: 150}
      ]
    },
    {
      year: '2018',
      approved: true,
      rows:[
        {rowCode: '01', rowName: '01', value: 200},
        {rowCode: '02', rowName: '02', value: 300},
        {rowCode: '03', rowName: '03', value: 150},
        {rowCode: '04', rowName: '04', value: 80},
        {rowCode: '05', rowName: '05', value: 200},
        {rowCode: '06', rowName: '06', value: 250},
        {rowCode: '07', rowName: '07', value: 180},
        {rowCode: '08', rowName: '08', value: 200},
        {rowCode: '09', rowName: '09', value: 400},
        {rowCode: '10', rowName: '10', value: 280},
        {rowCode: '11', rowName: '11', value: 100},
        {rowCode: '12', rowName: '12', value: 250}
      ]
    },
    {
      year: '2019',
      approved: false,
      rows:[
        {rowCode: '01', rowName: '01', value: 200},
        {rowCode: '02', rowName: '02', value: 100},
        {rowCode: '03', rowName: '03', value: 300},
        {rowCode: '04', rowName: '04', value: 100},
        {rowCode: '05', rowName: '05', value: 200},
        {rowCode: '06', rowName: '06', value: 350},
        {rowCode: '07', rowName: '07', value: 100},
        {rowCode: '08', rowName: '08', value: 200},
        {rowCode: '09', rowName: '09', value: 300},
        {rowCode: '10', rowName: '10', value: 280},
        {rowCode: '11', rowName: '11', value: 200},
        {rowCode: '12', rowName: '12', value: 250}
      ]
    }
  ]
};
export const mockFinanceReportOpu: IFinanceReportOpu = {
  companies: [
    {
      companyCode: '01',
      companyName: 'ООО Ромашка',
      isTotal: false,
      years: [
        {
          year: '2017',
          approved: true,
          rows: [
            {rowCode: '01', rowName: 'Выручка', value: 100, isBold: false, highlighted: true},
            {rowCode: '02', rowName: 'Себестоимость', value: 300, isBold: false, highlighted: true},
            {rowCode: '03', rowName: 'Валовая прибыль', value: 100, isBold: false, highlighted: false},
            {rowCode: '04', rowName: '% от выручки', value: 200, isBold: false, highlighted: false},
            {rowCode: '05', rowName: 'Коммерческие расходы', value: 700, isBold: false, highlighted: true},
            {rowCode: '06', rowName: 'Административные расходы', value: 200, isBold: false, highlighted: true},
            {rowCode: '07', rowName: 'Прибыль от продаж', value: 100, isBold: false, highlighted: false},
            {rowCode: '08', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '09', rowName: 'Доходы от участия в других организациях', value: 100, isBold: false, highlighted: true},
            {rowCode: '10', rowName: 'Проценты к получению', value: 100, isBold: false, highlighted: true},
            {rowCode: '11', rowName: 'Проценты к уплате', value: 100, isBold: false, highlighted: true},
            {rowCode: '12', rowName: 'Прочие доходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '13', rowName: 'Прочие расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '14', rowName: 'Прибыль до налогооблажения', value: 100},
            {rowCode: '15', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '16', rowName: 'Налог на прибыль', value: 100, isBold: false, highlighted: true},
            {rowCode: '17', rowName: 'Чистая прибыль', value: 100, isBold: false, highlighted: false},
            {rowCode: '18', rowName: '% от выручки', value: 100, isBold: false, highlighted: false}
          ]
        },
        {
          year: '2018',
          approved: true,
          rows: [
            {rowCode: '01', rowName: 'Выручка', value: 100, isBold: false, highlighted: true},
            {rowCode: '02', rowName: 'Себестоимость', value: 100, isBold: false, highlighted: true},
            {rowCode: '03', rowName: 'Валовая прибыль', value: 100, isBold: false, highlighted: false},
            {rowCode: '04', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '05', rowName: 'Коммерческие расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '06', rowName: 'Административные расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '07', rowName: 'Прибыль от продаж', value: 100, isBold: false, highlighted: false},
            {rowCode: '08', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '09', rowName: 'Доходы от участия в других организациях', value: 100, isBold: false, highlighted: true},
            {rowCode: '10', rowName: 'Проценты к получению', value: 100, isBold: false, highlighted: true},
            {rowCode: '11', rowName: 'Проценты к уплате', value: 100, isBold: false, highlighted: true},
            {rowCode: '12', rowName: 'Прочие доходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '13', rowName: 'Прочие расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '14', rowName: 'Прибыль до налогооблажения', value: 100},
            {rowCode: '15', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '16', rowName: 'Налог на прибыль', value: 100, isBold: false, highlighted: true},
            {rowCode: '17', rowName: 'Чистая прибыль', value: 100, isBold: false, highlighted: false},
            {rowCode: '18', rowName: '% от выручки', value: 100, isBold: false, highlighted: false}
          ]
        },
        {
          year: '2019',
          approved: true,
          rows: [
            {rowCode: '01', rowName: 'Выручка', value: 100, isBold: false, highlighted: true},
            {rowCode: '02', rowName: 'Себестоимость', value: 100, isBold: false, highlighted: true},
            {rowCode: '03', rowName: 'Валовая прибыль', value: 100, isBold: false, highlighted: false},
            {rowCode: '04', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '05', rowName: 'Коммерческие расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '06', rowName: 'Административные расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '07', rowName: 'Прибыль от продаж', value: 100, isBold: false, highlighted: false},
            {rowCode: '08', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '09', rowName: 'Доходы от участия в других организациях', value: 100, isBold: false, highlighted: true},
            {rowCode: '10', rowName: 'Проценты к получению', value: 100, isBold: false, highlighted: true},
            {rowCode: '11', rowName: 'Проценты к уплате', value: 100, isBold: false, highlighted: true},
            {rowCode: '12', rowName: 'Прочие доходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '13', rowName: 'Прочие расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '14', rowName: 'Прибыль до налогооблажения', value: 100},
            {rowCode: '15', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '16', rowName: 'Налог на прибыль', value: 100, isBold: false, highlighted: true},
            {rowCode: '17', rowName: 'Чистая прибыль', value: 100, isBold: false, highlighted: false},
            {rowCode: '18', rowName: '% от выручки', value: 100, isBold: false, highlighted: false}
          ]
        }
      ]
    },
    {
      companyCode: '02',
      companyName: 'ООО Роза',
      isTotal: false,
      years: [
        {
          year: '2017',
          approved: true,
          rows: [
            {rowCode: '01', rowName: 'Выручка', value: 100, isBold: false, highlighted: true},
            {rowCode: '02', rowName: 'Себестоимость', value: 100, isBold: false, highlighted: true},
            {rowCode: '03', rowName: 'Валовая прибыль', value: 100, isBold: false, highlighted: false},
            {rowCode: '04', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '05', rowName: 'Коммерческие расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '06', rowName: 'Административные расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '07', rowName: 'Прибыль от продаж', value: 100, isBold: false, highlighted: false},
            {rowCode: '08', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '09', rowName: 'Доходы от участия в других организациях', value: 100, isBold: false, highlighted: true},
            {rowCode: '10', rowName: 'Проценты к получению', value: 100, isBold: false, highlighted: true},
            {rowCode: '11', rowName: 'Проценты к уплате', value: 100, isBold: false, highlighted: true},
            {rowCode: '12', rowName: 'Прочие доходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '13', rowName: 'Прочие расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '14', rowName: 'Прибыль до налогооблажения', value: 100},
            {rowCode: '15', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '16', rowName: 'Налог на прибыль', value: 100, isBold: false, highlighted: true},
            {rowCode: '17', rowName: 'Чистая прибыль', value: 100, isBold: false, highlighted: false},
            {rowCode: '18', rowName: '% от выручки', value: 100, isBold: false, highlighted: false}
          ]
        },
        {
          year: '2018',
          approved: true,
          rows: [
            {rowCode: '01', rowName: 'Выручка', value: 100, isBold: false, highlighted: true},
            {rowCode: '02', rowName: 'Себестоимость', value: 100, isBold: false, highlighted: true},
            {rowCode: '03', rowName: 'Валовая прибыль', value: 100, isBold: false, highlighted: false},
            {rowCode: '04', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '05', rowName: 'Коммерческие расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '06', rowName: 'Административные расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '07', rowName: 'Прибыль от продаж', value: 100, isBold: false, highlighted: false},
            {rowCode: '08', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '09', rowName: 'Доходы от участия в других организациях', value: 100, isBold: false, highlighted: true},
            {rowCode: '10', rowName: 'Проценты к получению', value: 100, isBold: false, highlighted: true},
            {rowCode: '11', rowName: 'Проценты к уплате', value: 100, isBold: false, highlighted: true},
            {rowCode: '12', rowName: 'Прочие доходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '13', rowName: 'Прочие расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '14', rowName: 'Прибыль до налогооблажения', value: 100},
            {rowCode: '15', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '16', rowName: 'Налог на прибыль', value: 100, isBold: false, highlighted: true},
            {rowCode: '17', rowName: 'Чистая прибыль', value: 100, isBold: false, highlighted: false},
            {rowCode: '18', rowName: '% от выручки', value: 100, isBold: false, highlighted: false}
          ]
        },
        {
          year: '2019',
          approved: true,
          rows: [
            {rowCode: '01', rowName: 'Выручка', value: 100, isBold: false, highlighted: true},
            {rowCode: '02', rowName: 'Себестоимость', value: 100, isBold: false, highlighted: true},
            {rowCode: '03', rowName: 'Валовая прибыль', value: 100, isBold: false, highlighted: false},
            {rowCode: '04', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '05', rowName: 'Коммерческие расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '06', rowName: 'Административные расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '07', rowName: 'Прибыль от продаж', value: 100, isBold: false, highlighted: false},
            {rowCode: '08', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '09', rowName: 'Доходы от участия в других организациях', value: 100, isBold: false, highlighted: true},
            {rowCode: '10', rowName: 'Проценты к получению', value: 100, isBold: false, highlighted: true},
            {rowCode: '11', rowName: 'Проценты к уплате', value: 100, isBold: false, highlighted: true},
            {rowCode: '12', rowName: 'Прочие доходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '13', rowName: 'Прочие расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '14', rowName: 'Прибыль до налогооблажения', value: 100},
            {rowCode: '15', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '16', rowName: 'Налог на прибыль', value: 100, isBold: false, highlighted: true},
            {rowCode: '17', rowName: 'Чистая прибыль', value: 100, isBold: false, highlighted: false},
            {rowCode: '18', rowName: '% от выручки', value: 100, isBold: false, highlighted: false}
          ]
        }
      ]
    },
    {
      companyCode: '03',
      companyName: 'ООО Физалис',
      isTotal: false,
      years: [
        {
          year: '2017',
          approved: true,
          rows: [
            {rowCode: '01', rowName: 'Выручка', value: 100, isBold: false, highlighted: true},
            {rowCode: '02', rowName: 'Себестоимость', value: 100, isBold: false, highlighted: true},
            {rowCode: '03', rowName: 'Валовая прибыль', value: 100, isBold: false, highlighted: false},
            {rowCode: '04', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '05', rowName: 'Коммерческие расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '06', rowName: 'Административные расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '07', rowName: 'Прибыль от продаж', value: 100, isBold: false, highlighted: false},
            {rowCode: '08', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '09', rowName: 'Доходы от участия в других организациях', value: 100, isBold: false, highlighted: true},
            {rowCode: '10', rowName: 'Проценты к получению', value: 100, isBold: false, highlighted: true},
            {rowCode: '11', rowName: 'Проценты к уплате', value: 100, isBold: false, highlighted: true},
            {rowCode: '12', rowName: 'Прочие доходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '13', rowName: 'Прочие расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '14', rowName: 'Прибыль до налогооблажения', value: 100},
            {rowCode: '15', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '16', rowName: 'Налог на прибыль', value: 100, isBold: false, highlighted: true},
            {rowCode: '17', rowName: 'Чистая прибыль', value: 100, isBold: false, highlighted: false},
            {rowCode: '18', rowName: '% от выручки', value: 100, isBold: false, highlighted: false}
          ]
        },
        {
          year: '2018',
          approved: true,
          rows: [
            {rowCode: '01', rowName: 'Выручка', value: 100, isBold: false, highlighted: true},
            {rowCode: '02', rowName: 'Себестоимость', value: 100, isBold: false, highlighted: true},
            {rowCode: '03', rowName: 'Валовая прибыль', value: 100, isBold: false, highlighted: false},
            {rowCode: '04', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '05', rowName: 'Коммерческие расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '06', rowName: 'Административные расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '07', rowName: 'Прибыль от продаж', value: 100, isBold: false, highlighted: false},
            {rowCode: '08', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '09', rowName: 'Доходы от участия в других организациях', value: 100, isBold: false, highlighted: true},
            {rowCode: '10', rowName: 'Проценты к получению', value: 100, isBold: false, highlighted: true},
            {rowCode: '11', rowName: 'Проценты к уплате', value: 100, isBold: false, highlighted: true},
            {rowCode: '12', rowName: 'Прочие доходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '13', rowName: 'Прочие расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '14', rowName: 'Прибыль до налогооблажения', value: 100},
            {rowCode: '15', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '16', rowName: 'Налог на прибыль', value: 100, isBold: false, highlighted: true},
            {rowCode: '17', rowName: 'Чистая прибыль', value: 100, isBold: false, highlighted: false},
            {rowCode: '18', rowName: '% от выручки', value: 100, isBold: false, highlighted: false}
          ]
        },
        {
          year: '2019',
          approved: true,
          rows: [
            {rowCode: '01', rowName: 'Выручка', value: 100, isBold: false, highlighted: true},
            {rowCode: '02', rowName: 'Себестоимость', value: 100, isBold: false, highlighted: true},
            {rowCode: '03', rowName: 'Валовая прибыль', value: 100, isBold: false, highlighted: false},
            {rowCode: '04', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '05', rowName: 'Коммерческие расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '06', rowName: 'Административные расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '07', rowName: 'Прибыль от продаж', value: 100, isBold: false, highlighted: false},
            {rowCode: '08', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '09', rowName: 'Доходы от участия в других организациях', value: 100, isBold: false, highlighted: true},
            {rowCode: '10', rowName: 'Проценты к получению', value: 100, isBold: false, highlighted: true},
            {rowCode: '11', rowName: 'Проценты к уплате', value: 100, isBold: false, highlighted: true},
            {rowCode: '12', rowName: 'Прочие доходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '13', rowName: 'Прочие расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '14', rowName: 'Прибыль до налогооблажения', value: 100},
            {rowCode: '15', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '16', rowName: 'Налог на прибыль', value: 100, isBold: false, highlighted: true},
            {rowCode: '17', rowName: 'Чистая прибыль', value: 100, isBold: false, highlighted: false},
            {rowCode: '18', rowName: '% от выручки', value: 100, isBold: false, highlighted: false}
          ]
        }
      ]
    },
    {
      companyCode: '04',
      companyName: 'Консолидация',
      isTotal: true,
      years: [
        {
          year: '2017',
          approved: true,
          rows: [
            {rowCode: '01', rowName: 'Выручка', value: 100, isBold: false, highlighted: true},
            {rowCode: '02', rowName: 'Себестоимость', value: 100, isBold: false, highlighted: true},
            {rowCode: '03', rowName: 'Валовая прибыль', value: 100, isBold: false, highlighted: false},
            {rowCode: '04', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '05', rowName: 'Коммерческие расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '06', rowName: 'Административные расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '07', rowName: 'Прибыль от продаж', value: 100, isBold: false, highlighted: false},
            {rowCode: '08', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '09', rowName: 'Доходы от участия в других организациях', value: 100, isBold: false, highlighted: true},
            {rowCode: '10', rowName: 'Проценты к получению', value: 100, isBold: false, highlighted: true},
            {rowCode: '11', rowName: 'Проценты к уплате', value: 100, isBold: false, highlighted: true},
            {rowCode: '12', rowName: 'Прочие доходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '13', rowName: 'Прочие расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '14', rowName: 'Прибыль до налогооблажения', value: 100},
            {rowCode: '15', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '16', rowName: 'Налог на прибыль', value: 100, isBold: false, highlighted: true},
            {rowCode: '17', rowName: 'Чистая прибыль', value: 100, isBold: false, highlighted: false},
            {rowCode: '18', rowName: '% от выручки', value: 100, isBold: false, highlighted: false}
          ]
        },
        {
          year: '2018',
          approved: true,
          rows: [
            {rowCode: '01', rowName: 'Выручка', value: 100, isBold: false, highlighted: true},
            {rowCode: '02', rowName: 'Себестоимость', value: 100, isBold: false, highlighted: true},
            {rowCode: '03', rowName: 'Валовая прибыль', value: 100, isBold: false, highlighted: false},
            {rowCode: '04', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '05', rowName: 'Коммерческие расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '06', rowName: 'Административные расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '07', rowName: 'Прибыль от продаж', value: 100, isBold: false, highlighted: false},
            {rowCode: '08', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '09', rowName: 'Доходы от участия в других организациях', value: 100, isBold: false, highlighted: true},
            {rowCode: '10', rowName: 'Проценты к получению', value: 100, isBold: false, highlighted: true},
            {rowCode: '11', rowName: 'Проценты к уплате', value: 100, isBold: false, highlighted: true},
            {rowCode: '12', rowName: 'Прочие доходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '13', rowName: 'Прочие расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '14', rowName: 'Прибыль до налогооблажения', value: 100},
            {rowCode: '15', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '16', rowName: 'Налог на прибыль', value: 100, isBold: false, highlighted: true},
            {rowCode: '17', rowName: 'Чистая прибыль', value: 100, isBold: false, highlighted: false},
            {rowCode: '18', rowName: '% от выручки', value: 100, isBold: false, highlighted: false}
          ]
        },
        {
          year: '2019',
          approved: true,
          rows: [
            {rowCode: '01', rowName: 'Выручка', value: 100, isBold: false, highlighted: true},
            {rowCode: '02', rowName: 'Себестоимость', value: 100, isBold: false, highlighted: true},
            {rowCode: '03', rowName: 'Валовая прибыль', value: 100, isBold: false, highlighted: false},
            {rowCode: '04', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '05', rowName: 'Коммерческие расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '06', rowName: 'Административные расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '07', rowName: 'Прибыль от продаж', value: 100, isBold: false, highlighted: false},
            {rowCode: '08', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '09', rowName: 'Доходы от участия в других организациях', value: 100, isBold: false, highlighted: true},
            {rowCode: '10', rowName: 'Проценты к получению', value: 100, isBold: false, highlighted: true},
            {rowCode: '11', rowName: 'Проценты к уплате', value: 100, isBold: false, highlighted: true},
            {rowCode: '12', rowName: 'Прочие доходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '13', rowName: 'Прочие расходы', value: 100, isBold: false, highlighted: true},
            {rowCode: '14', rowName: 'Прибыль до налогооблажения', value: 100},
            {rowCode: '15', rowName: '% от выручки', value: 100, isBold: false, highlighted: false},
            {rowCode: '16', rowName: 'Налог на прибыль', value: 100, isBold: false, highlighted: true},
            {rowCode: '17', rowName: 'Чистая прибыль', value: 100, isBold: false, highlighted: false},
            {rowCode: '18', rowName: '% от выручки', value: 100, isBold: false, highlighted: false}
          ]
        }
      ]
    }
  ]
};
export const mockFinanceReportBalance: IFinanceReportBalance = {
  companies: [
    {
      companyCode: '01',
      companyName: 'ООО Ромашка',
      isTotal: false,
      years: [
        {
          year: '2017',
          approved: true,
          rows: [
            {rowCode: '01', rowName: 'Нематериальные активы', value: 100, isBold: false, highlighted: false},
            {rowCode: '02', rowName: 'Основные средства', value: 100, isBold: false, highlighted: false},
            {rowCode: '03', rowName: 'Финансовые вложения', value: 100, isBold: false, highlighted: false},
            {rowCode: '04', rowName: 'Прочие внеоборотные активы', value: 100, isBold: false, highlighted: false},
            {rowCode: '05', rowName: 'Внеоборотные активы', value: 100, isBold: true, highlighted: true},
            {rowCode: '06', rowName: 'Запасы', value: 100, isBold: false, highlighted: false},
            {rowCode: '07', rowName: 'НДС', value: 100, isBold: false, highlighted: false},
            {rowCode: '08', rowName: 'Дебеторская задолженность', value: 100, isBold: false, highlighted: false},
            {rowCode: '09', rowName: 'Денежные средства', value: 100, isBold: false, highlighted: false},
            {rowCode: '10', rowName: 'Прочие оборотные автивы', value: 100, isBold: false, highlighted: false},
            {rowCode: '11', rowName: 'Оборотные активы', value: 100, isBold: true, highlighted: true},
            {rowCode: '12', rowName: 'Капитал', value: 100, isBold: true, highlighted: false},
            {rowCode: '13', rowName: 'Краткосрочные займы', value: 100, isBold: false, highlighted: true},
            {rowCode: '14', rowName: 'Кредиторская задолженность', value: 100, isBold: false, highlighted: true},
            {rowCode: '15', rowName: 'Краткосрочные обязательства', value: 100, isBold: true, highlighted: false},
            {rowCode: '16', rowName: 'Долгосрочные займы', value: 100, isBold: false, highlighted: true},
            {rowCode: '17', rowName: 'Прочие обязательства', value: 100, isBold: false, highlighted: true},
            {rowCode: '18', rowName: 'Долгосрочные обязательства', value: 100, isBold: true, highlighted: false}
          ]
        },
        {
          year: '2018',
          approved: true,
          rows: [
            {rowCode: '01', rowName: 'Нематериальные активы', value: 100, isBold: false, highlighted: false},
            {rowCode: '02', rowName: 'Основные средства', value: 100, isBold: false, highlighted: false},
            {rowCode: '03', rowName: 'Финансовые вложения', value: 100, isBold: false, highlighted: false},
            {rowCode: '04', rowName: 'Прочие внеоборотные активы', value: 100, isBold: false, highlighted: false},
            {rowCode: '05', rowName: 'Внеоборотные активы', value: 100, isBold: true, highlighted: true},
            {rowCode: '06', rowName: 'Запасы', value: 100, isBold: false, highlighted: false},
            {rowCode: '07', rowName: 'НДС', value: 100, isBold: false, highlighted: false},
            {rowCode: '08', rowName: 'Дебеторская задолженность', value: 100, isBold: false, highlighted: false},
            {rowCode: '09', rowName: 'Денежные средства', value: 100, isBold: false, highlighted: false},
            {rowCode: '10', rowName: 'Прочие оборотные автивы', value: 100, isBold: false, highlighted: false},
            {rowCode: '11', rowName: 'Оборотные активы', value: 100, isBold: true, highlighted: true},
            {rowCode: '12', rowName: 'Капитал', value: 100, isBold: true, highlighted: false},
            {rowCode: '13', rowName: 'Краткосрочные займы', value: 100, isBold: false, highlighted: true},
            {rowCode: '14', rowName: 'Кредиторская задолженность', value: 100, isBold: false, highlighted: true},
            {rowCode: '15', rowName: 'Краткосрочные обязательства', value: 100, isBold: true, highlighted: false},
            {rowCode: '16', rowName: 'Долгосрочные займы', value: 100, isBold: false, highlighted: true},
            {rowCode: '17', rowName: 'Прочие обязательства', value: 100, isBold: false, highlighted: true},
            {rowCode: '18', rowName: 'Долгосрочные обязательства', value: 100, isBold: true, highlighted: false}
          ]
        },
        {
          year: '2019',
          approved: false,
          rows: [
            {rowCode: '01', rowName: 'Нематериальные активы', value: 100, isBold: false, highlighted: false},
            {rowCode: '02', rowName: 'Основные средства', value: 100, isBold: false, highlighted: false},
            {rowCode: '03', rowName: 'Финансовые вложения', value: 100, isBold: false, highlighted: false},
            {rowCode: '04', rowName: 'Прочие внеоборотные активы', value: 100, isBold: false, highlighted: false},
            {rowCode: '05', rowName: 'Внеоборотные активы', value: 100, isBold: true, highlighted: true},
            {rowCode: '06', rowName: 'Запасы', value: 100, isBold: false, highlighted: false},
            {rowCode: '07', rowName: 'НДС', value: 100, isBold: false, highlighted: false},
            {rowCode: '08', rowName: 'Дебеторская задолженность', value: 100, isBold: false, highlighted: false},
            {rowCode: '09', rowName: 'Денежные средства', value: 100, isBold: false, highlighted: false},
            {rowCode: '10', rowName: 'Прочие оборотные автивы', value: 100, isBold: false, highlighted: false},
            {rowCode: '11', rowName: 'Оборотные активы', value: 100, isBold: true, highlighted: true},
            {rowCode: '12', rowName: 'Капитал', value: 100, isBold: true, highlighted: false},
            {rowCode: '13', rowName: 'Краткосрочные займы', value: 100, isBold: false, highlighted: true},
            {rowCode: '14', rowName: 'Кредиторская задолженность', value: 100, isBold: false, highlighted: true},
            {rowCode: '15', rowName: 'Краткосрочные обязательства', value: 100, isBold: true, highlighted: false},
            {rowCode: '16', rowName: 'Долгосрочные займы', value: 100, isBold: false, highlighted: true},
            {rowCode: '17', rowName: 'Прочие обязательства', value: 100, isBold: false, highlighted: true},
            {rowCode: '18', rowName: 'Долгосрочные обязательства', value: 100, isBold: true, highlighted: false}
          ]
        }
      ]
    },
    {
      companyCode: '02',
      companyName: 'ООО Роза',
      isTotal: false,
      years: [
        {
          year: '2017',
          approved: true,
          rows: [
            {rowCode: '01', rowName: 'Нематериальные активы', value: 100, isBold: false, highlighted: false},
            {rowCode: '02', rowName: 'Основные средства', value: 100, isBold: false, highlighted: false},
            {rowCode: '03', rowName: 'Финансовые вложения', value: 100, isBold: false, highlighted: false},
            {rowCode: '04', rowName: 'Прочие внеоборотные активы', value: 100, isBold: false, highlighted: false},
            {rowCode: '05', rowName: 'Внеоборотные активы', value: 100, isBold: true, highlighted: true},
            {rowCode: '06', rowName: 'Запасы', value: 100, isBold: false, highlighted: false},
            {rowCode: '07', rowName: 'НДС', value: 100, isBold: false, highlighted: false},
            {rowCode: '08', rowName: 'Дебеторская задолженность', value: 100, isBold: false, highlighted: false},
            {rowCode: '09', rowName: 'Денежные средства', value: 100, isBold: false, highlighted: false},
            {rowCode: '10', rowName: 'Прочие оборотные автивы', value: 100, isBold: false, highlighted: false},
            {rowCode: '11', rowName: 'Оборотные активы', value: 100, isBold: true, highlighted: true},
            {rowCode: '12', rowName: 'Капитал', value: 100, isBold: true, highlighted: false},
            {rowCode: '13', rowName: 'Краткосрочные займы', value: 100, isBold: false, highlighted: true},
            {rowCode: '14', rowName: 'Кредиторская задолженность', value: 100, isBold: false, highlighted: true},
            {rowCode: '15', rowName: 'Краткосрочные обязательства', value: 100, isBold: true, highlighted: false},
            {rowCode: '16', rowName: 'Долгосрочные займы', value: 100, isBold: false, highlighted: true},
            {rowCode: '17', rowName: 'Прочие обязательства', value: 100, isBold: false, highlighted: true},
            {rowCode: '18', rowName: 'Долгосрочные обязательства', value: 100, isBold: true, highlighted: false}
          ]
        },
        {
          year: '2018',
          approved: true,
          rows: [
            {rowCode: '01', rowName: 'Нематериальные активы', value: 100, isBold: false, highlighted: false},
            {rowCode: '02', rowName: 'Основные средства', value: 100, isBold: false, highlighted: false},
            {rowCode: '03', rowName: 'Финансовые вложения', value: 100, isBold: false, highlighted: false},
            {rowCode: '04', rowName: 'Прочие внеоборотные активы', value: 100, isBold: false, highlighted: false},
            {rowCode: '05', rowName: 'Внеоборотные активы', value: 100, isBold: true, highlighted: true},
            {rowCode: '06', rowName: 'Запасы', value: 100, isBold: false, highlighted: false},
            {rowCode: '07', rowName: 'НДС', value: 100, isBold: false, highlighted: false},
            {rowCode: '08', rowName: 'Дебеторская задолженность', value: 100, isBold: false, highlighted: false},
            {rowCode: '09', rowName: 'Денежные средства', value: 100, isBold: false, highlighted: false},
            {rowCode: '10', rowName: 'Прочие оборотные автивы', value: 100, isBold: false, highlighted: false},
            {rowCode: '11', rowName: 'Оборотные активы', value: 100, isBold: true, highlighted: true},
            {rowCode: '12', rowName: 'Капитал', value: 100, isBold: true, highlighted: false},
            {rowCode: '13', rowName: 'Краткосрочные займы', value: 100, isBold: false, highlighted: true},
            {rowCode: '14', rowName: 'Кредиторская задолженность', value: 100, isBold: false, highlighted: true},
            {rowCode: '15', rowName: 'Краткосрочные обязательства', value: 100, isBold: true, highlighted: false},
            {rowCode: '16', rowName: 'Долгосрочные займы', value: 100, isBold: false, highlighted: true},
            {rowCode: '17', rowName: 'Прочие обязательства', value: 100, isBold: false, highlighted: true},
            {rowCode: '18', rowName: 'Долгосрочные обязательства', value: 100, isBold: true, highlighted: false}
          ]
        },
        {
          year: '2019',
          approved: false,
          rows: [
            {rowCode: '01', rowName: 'Нематериальные активы', value: 100, isBold: false, highlighted: false},
            {rowCode: '02', rowName: 'Основные средства', value: 100, isBold: false, highlighted: false},
            {rowCode: '03', rowName: 'Финансовые вложения', value: 100, isBold: false, highlighted: false},
            {rowCode: '04', rowName: 'Прочие внеоборотные активы', value: 100, isBold: false, highlighted: false},
            {rowCode: '05', rowName: 'Внеоборотные активы', value: 100, isBold: true, highlighted: true},
            {rowCode: '06', rowName: 'Запасы', value: 100, isBold: false, highlighted: false},
            {rowCode: '07', rowName: 'НДС', value: 100, isBold: false, highlighted: false},
            {rowCode: '08', rowName: 'Дебеторская задолженность', value: 100, isBold: false, highlighted: false},
            {rowCode: '09', rowName: 'Денежные средства', value: 100, isBold: false, highlighted: false},
            {rowCode: '10', rowName: 'Прочие оборотные автивы', value: 100, isBold: false, highlighted: false},
            {rowCode: '11', rowName: 'Оборотные активы', value: 100, isBold: true, highlighted: true},
            {rowCode: '12', rowName: 'Капитал', value: 100, isBold: true, highlighted: false},
            {rowCode: '13', rowName: 'Краткосрочные займы', value: 100, isBold: false, highlighted: true},
            {rowCode: '14', rowName: 'Кредиторская задолженность', value: 100, isBold: false, highlighted: true},
            {rowCode: '15', rowName: 'Краткосрочные обязательства', value: 100, isBold: true, highlighted: false},
            {rowCode: '16', rowName: 'Долгосрочные займы', value: 100, isBold: false, highlighted: true},
            {rowCode: '17', rowName: 'Прочие обязательства', value: 100, isBold: false, highlighted: true},
            {rowCode: '18', rowName: 'Долгосрочные обязательства', value: 100, isBold: true, highlighted: false}
          ]
        }
      ]
    },
    {
      companyCode: '03',
      companyName: 'ООО Физалис',
      isTotal: false,
      years: [
        {
          year: '2017',
          approved: true,
          rows: [
            {rowCode: '01', rowName: 'Нематериальные активы', value: 100, isBold: false, highlighted: false},
            {rowCode: '02', rowName: 'Основные средства', value: 100, isBold: false, highlighted: false},
            {rowCode: '03', rowName: 'Финансовые вложения', value: 100, isBold: false, highlighted: false},
            {rowCode: '04', rowName: 'Прочие внеоборотные активы', value: 100, isBold: false, highlighted: false},
            {rowCode: '05', rowName: 'Внеоборотные активы', value: 100, isBold: true, highlighted: true},
            {rowCode: '06', rowName: 'Запасы', value: 100, isBold: false, highlighted: false},
            {rowCode: '07', rowName: 'НДС', value: 100, isBold: false, highlighted: false},
            {rowCode: '08', rowName: 'Дебеторская задолженность', value: 100, isBold: false, highlighted: false},
            {rowCode: '09', rowName: 'Денежные средства', value: 100, isBold: false, highlighted: false},
            {rowCode: '10', rowName: 'Прочие оборотные автивы', value: 100, isBold: false, highlighted: false},
            {rowCode: '11', rowName: 'Оборотные активы', value: 100, isBold: true, highlighted: true},
            {rowCode: '12', rowName: 'Капитал', value: 100, isBold: true, highlighted: false},
            {rowCode: '13', rowName: 'Краткосрочные займы', value: 100, isBold: false, highlighted: true},
            {rowCode: '14', rowName: 'Кредиторская задолженность', value: 100, isBold: false, highlighted: true},
            {rowCode: '15', rowName: 'Краткосрочные обязательства', value: 100, isBold: true, highlighted: false},
            {rowCode: '16', rowName: 'Долгосрочные займы', value: 100, isBold: false, highlighted: true},
            {rowCode: '17', rowName: 'Прочие обязательства', value: 100, isBold: false, highlighted: true},
            {rowCode: '18', rowName: 'Долгосрочные обязательства', value: 100, isBold: true, highlighted: false}
          ]
        },
        {
          year: '2018',
          approved: true,
          rows: [
            {rowCode: '01', rowName: 'Нематериальные активы', value: 100, isBold: false, highlighted: false},
            {rowCode: '02', rowName: 'Основные средства', value: 100, isBold: false, highlighted: false},
            {rowCode: '03', rowName: 'Финансовые вложения', value: 100, isBold: false, highlighted: false},
            {rowCode: '04', rowName: 'Прочие внеоборотные активы', value: 100, isBold: false, highlighted: false},
            {rowCode: '05', rowName: 'Внеоборотные активы', value: 100, isBold: true, highlighted: true},
            {rowCode: '06', rowName: 'Запасы', value: 100, isBold: false, highlighted: false},
            {rowCode: '07', rowName: 'НДС', value: 100, isBold: false, highlighted: false},
            {rowCode: '08', rowName: 'Дебеторская задолженность', value: 100, isBold: false, highlighted: false},
            {rowCode: '09', rowName: 'Денежные средства', value: 100, isBold: false, highlighted: false},
            {rowCode: '10', rowName: 'Прочие оборотные автивы', value: 100, isBold: false, highlighted: false},
            {rowCode: '11', rowName: 'Оборотные активы', value: 100, isBold: true, highlighted: true},
            {rowCode: '12', rowName: 'Капитал', value: 100, isBold: true, highlighted: false},
            {rowCode: '13', rowName: 'Краткосрочные займы', value: 100, isBold: false, highlighted: true},
            {rowCode: '14', rowName: 'Кредиторская задолженность', value: 100, isBold: false, highlighted: true},
            {rowCode: '15', rowName: 'Краткосрочные обязательства', value: 100, isBold: true, highlighted: false},
            {rowCode: '16', rowName: 'Долгосрочные займы', value: 100, isBold: false, highlighted: true},
            {rowCode: '17', rowName: 'Прочие обязательства', value: 100, isBold: false, highlighted: true},
            {rowCode: '18', rowName: 'Долгосрочные обязательства', value: 100, isBold: true, highlighted: false}
          ]
        },
        {
          year: '2019',
          approved: false,
          rows: [
            {rowCode: '01', rowName: 'Нематериальные активы', value: 100, isBold: false, highlighted: false},
            {rowCode: '02', rowName: 'Основные средства', value: 100, isBold: false, highlighted: false},
            {rowCode: '03', rowName: 'Финансовые вложения', value: 100, isBold: false, highlighted: false},
            {rowCode: '04', rowName: 'Прочие внеоборотные активы', value: 100, isBold: false, highlighted: false},
            {rowCode: '05', rowName: 'Внеоборотные активы', value: 100, isBold: true, highlighted: true},
            {rowCode: '06', rowName: 'Запасы', value: 100, isBold: false, highlighted: false},
            {rowCode: '07', rowName: 'НДС', value: 100, isBold: false, highlighted: false},
            {rowCode: '08', rowName: 'Дебеторская задолженность', value: 100, isBold: false, highlighted: false},
            {rowCode: '09', rowName: 'Денежные средства', value: 100, isBold: false, highlighted: false},
            {rowCode: '10', rowName: 'Прочие оборотные автивы', value: 100, isBold: false, highlighted: false},
            {rowCode: '11', rowName: 'Оборотные активы', value: 100, isBold: true, highlighted: true},
            {rowCode: '12', rowName: 'Капитал', value: 100, isBold: true, highlighted: false},
            {rowCode: '13', rowName: 'Краткосрочные займы', value: 100, isBold: false, highlighted: true},
            {rowCode: '14', rowName: 'Кредиторская задолженность', value: 100, isBold: false, highlighted: true},
            {rowCode: '15', rowName: 'Краткосрочные обязательства', value: 100, isBold: true, highlighted: false},
            {rowCode: '16', rowName: 'Долгосрочные займы', value: 100, isBold: false, highlighted: true},
            {rowCode: '17', rowName: 'Прочие обязательства', value: 100, isBold: false, highlighted: true},
            {rowCode: '18', rowName: 'Долгосрочные обязательства', value: 100, isBold: true, highlighted: false}
          ]
        }
      ]
    },
    {
      companyCode: '04',
      companyName: 'Консолидация',
      isTotal: true,
      years: [
        {
          year: '2017',
          approved: true,
          rows: [
            {rowCode: '01', rowName: 'Нематериальные активы', value: 100, isBold: false, highlighted: false},
            {rowCode: '02', rowName: 'Основные средства', value: 100, isBold: false, highlighted: false},
            {rowCode: '03', rowName: 'Финансовые вложения', value: 100, isBold: false, highlighted: false},
            {rowCode: '04', rowName: 'Прочие внеоборотные активы', value: 100, isBold: false, highlighted: false},
            {rowCode: '05', rowName: 'Внеоборотные активы', value: 100, isBold: true, highlighted: true},
            {rowCode: '06', rowName: 'Запасы', value: 100, isBold: false, highlighted: false},
            {rowCode: '07', rowName: 'НДС', value: 100, isBold: false, highlighted: false},
            {rowCode: '08', rowName: 'Дебеторская задолженность', value: 100, isBold: false, highlighted: false},
            {rowCode: '09', rowName: 'Денежные средства', value: 100, isBold: false, highlighted: false},
            {rowCode: '10', rowName: 'Прочие оборотные автивы', value: 100, isBold: false, highlighted: false},
            {rowCode: '11', rowName: 'Оборотные активы', value: 100, isBold: true, highlighted: true},
            {rowCode: '12', rowName: 'Капитал', value: 100, isBold: true, highlighted: false},
            {rowCode: '13', rowName: 'Краткосрочные займы', value: 100, isBold: false, highlighted: true},
            {rowCode: '14', rowName: 'Кредиторская задолженность', value: 100, isBold: false, highlighted: true},
            {rowCode: '15', rowName: 'Краткосрочные обязательства', value: 100, isBold: true, highlighted: false},
            {rowCode: '16', rowName: 'Долгосрочные займы', value: 100, isBold: false, highlighted: true},
            {rowCode: '17', rowName: 'Прочие обязательства', value: 100, isBold: false, highlighted: true},
            {rowCode: '18', rowName: 'Долгосрочные обязательства', value: 100, isBold: true, highlighted: false}
          ]
        },
        {
          year: '2018',
          approved: true,
          rows: [
            {rowCode: '01', rowName: 'Нематериальные активы', value: 100, isBold: false, highlighted: false},
            {rowCode: '02', rowName: 'Основные средства', value: 100, isBold: false, highlighted: false},
            {rowCode: '03', rowName: 'Финансовые вложения', value: 100, isBold: false, highlighted: false},
            {rowCode: '04', rowName: 'Прочие внеоборотные активы', value: 100, isBold: false, highlighted: false},
            {rowCode: '05', rowName: 'Внеоборотные активы', value: 100, isBold: true, highlighted: true},
            {rowCode: '06', rowName: 'Запасы', value: 100, isBold: false, highlighted: false},
            {rowCode: '07', rowName: 'НДС', value: 100, isBold: false, highlighted: false},
            {rowCode: '08', rowName: 'Дебеторская задолженность', value: 100, isBold: false, highlighted: false},
            {rowCode: '09', rowName: 'Денежные средства', value: 100, isBold: false, highlighted: false},
            {rowCode: '10', rowName: 'Прочие оборотные автивы', value: 100, isBold: false, highlighted: false},
            {rowCode: '11', rowName: 'Оборотные активы', value: 100, isBold: true, highlighted: true},
            {rowCode: '12', rowName: 'Капитал', value: 100, isBold: true, highlighted: false},
            {rowCode: '13', rowName: 'Краткосрочные займы', value: 100, isBold: false, highlighted: true},
            {rowCode: '14', rowName: 'Кредиторская задолженность', value: 100, isBold: false, highlighted: true},
            {rowCode: '15', rowName: 'Краткосрочные обязательства', value: 100, isBold: true, highlighted: false},
            {rowCode: '16', rowName: 'Долгосрочные займы', value: 100, isBold: false, highlighted: true},
            {rowCode: '17', rowName: 'Прочие обязательства', value: 100, isBold: false, highlighted: true},
            {rowCode: '18', rowName: 'Долгосрочные обязательства', value: 100, isBold: true, highlighted: false}
          ]
        },
        {
          year: '2019',
          approved: false,
          rows: [
            {rowCode: '01', rowName: 'Нематериальные активы', value: 100, isBold: false, highlighted: false},
            {rowCode: '02', rowName: 'Основные средства', value: 100, isBold: false, highlighted: false},
            {rowCode: '03', rowName: 'Финансовые вложения', value: 100, isBold: false, highlighted: false},
            {rowCode: '04', rowName: 'Прочие внеоборотные активы', value: 100, isBold: false, highlighted: false},
            {rowCode: '05', rowName: 'Внеоборотные активы', value: 100, isBold: true, highlighted: true},
            {rowCode: '06', rowName: 'Запасы', value: 100, isBold: false, highlighted: false},
            {rowCode: '07', rowName: 'НДС', value: 100, isBold: false, highlighted: false},
            {rowCode: '08', rowName: 'Дебеторская задолженность', value: 100, isBold: false, highlighted: false},
            {rowCode: '09', rowName: 'Денежные средства', value: 100, isBold: false, highlighted: false},
            {rowCode: '10', rowName: 'Прочие оборотные автивы', value: 100, isBold: false, highlighted: false},
            {rowCode: '11', rowName: 'Оборотные активы', value: 100, isBold: true, highlighted: true},
            {rowCode: '12', rowName: 'Капитал', value: 100, isBold: true, highlighted: false},
            {rowCode: '13', rowName: 'Краткосрочные займы', value: 100, isBold: false, highlighted: true},
            {rowCode: '14', rowName: 'Кредиторская задолженность', value: 100, isBold: false, highlighted: true},
            {rowCode: '15', rowName: 'Краткосрочные обязательства', value: 100, isBold: true, highlighted: false},
            {rowCode: '16', rowName: 'Долгосрочные займы', value: 100, isBold: false, highlighted: true},
            {rowCode: '17', rowName: 'Прочие обязательства', value: 100, isBold: false, highlighted: true},
            {rowCode: '18', rowName: 'Долгосрочные обязательства', value: 100, isBold: true, highlighted: false}
          ]
        }
      ]
    }
  ]
};


